import React from 'react';
import styled from 'styled-components';

const Tooltip = styled.div`
    width: 120px;
    position: absolute;
    top: -60px;
    left: 60%;
    padding: 8px;
    background-color: #333;
    color: #fff;
    font-size: 14px;
    text-align: center;
`;

const ChoiceButtons = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 8px;
`;

const ChoiceButton = styled.button`
    padding: 4px 8px;
    background-color: #fff;
    color: #333;
    border: none;
    border-radius: 4px;
    cursor: pointer;

    &:hover {
        background-color: #ccc;
    }
`;
const ConfirmDeleteTooltip = ({ onYesClick, onNoClick }: { onYesClick: () => void; onNoClick: () => void }) => (
    <Tooltip>
        Confirm Delete?
        <ChoiceButtons>
            <ChoiceButton onClick={onYesClick}>Yes</ChoiceButton>
            <ChoiceButton onClick={onNoClick}>No</ChoiceButton>
        </ChoiceButtons>
    </Tooltip>
);

export default ConfirmDeleteTooltip;
